import React, { useEffect, useState } from "react";
import api from "../lib/api";
import TrackCard from "../components/TrackCard";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

export default function Catalog() {
  const [tracks, setTracks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");
  const [genre, setGenre] = useState("all");
  const { user } = useAuth();
  const [playlists, setPlaylists] = useState([]);

  useEffect(() => {
    api.get("/tracks").then(({ data }) => setTracks(data)).finally(() => setLoading(false));
    if (user) api.get("/playlists").then(({ data }) => setPlaylists(data)).catch(() => {});
  }, [user]);

  const genres = ["all", ...new Set(tracks.map((t) => t.genre))];
  const filtered = tracks.filter((t) => {
    const q = query.toLowerCase();
    return (genre === "all" || t.genre === genre) &&
      (t.title.toLowerCase().includes(q) || t.genre.toLowerCase().includes(q));
  });

  const handleAddToPlaylist = async (track) => {
    if (!user) return toast.error("Sign in to create playlists");
    let target = playlists[0];
    if (!target) {
      const { data } = await api.post("/playlists", { name: "My Playlist" });
      target = data;
      setPlaylists([data]);
    }
    try {
      await api.post(`/playlists/${target.id}/tracks`, { track_id: track.id });
      toast.success(`Added to "${target.name}"`);
    } catch {
      toast.error("Add failed");
    }
  };

  return (
    <div className="container-x py-16">
      <div className="eyebrow mb-4">// The Vault</div>
      <h1 className="section-heading mb-8">Catalog</h1>

      <div className="flex flex-wrap gap-4 mb-10 items-center">
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search title or genre..."
          className="bg-[#121217] border border-white/10 px-4 py-3 flex-1 min-w-[200px] focus:outline-none focus:border-[#FF5E00] font-mono-plex text-sm"
          data-testid="catalog-search-input"
        />
        <div className="flex gap-2 flex-wrap">
          {genres.map((g) => (
            <button
              key={g}
              onClick={() => setGenre(g)}
              className={`px-4 py-2 text-xs font-mono-plex uppercase tracking-widest border transition-colors ${
                genre === g ? "bg-[#FF5E00] border-[#FF5E00] text-white" : "border-white/10 text-white/60 hover:border-white/30"
              }`}
              data-testid={`genre-filter-${g}`}
            >{g}</button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="text-center text-white/40 py-20 font-mono-plex uppercase tracking-widest text-xs">Loading tracks...</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {filtered.map((t) => (
            <TrackCard key={t.id} track={t} onAddToPlaylist={user ? handleAddToPlaylist : null} />
          ))}
        </div>
      )}
      <div className="h-32" />
    </div>
  );
}
